import { render, staticRenderFns } from "./TenderEgreement.vue?vue&type=template&id=0ca62e04"
import script from "./TenderEgreement.vue?vue&type=script&lang=js"
export * from "./TenderEgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports